import TAxios from '../../../http/requests/testing-subjects/index.js'
export default {
    openCreationModal ({commit}, payload) {
        commit('OPEN_CREATION_MODAL', payload.open);
        if (payload.data) {
          commit('SET_CREATE_MODAL_DATA', payload.data);
        }
    },
    setData ({ commit }, data) {
        commit('SET_CREATE_MODAL_DATA', data);
    },
    changeEnabled({commit}, data) {
        let id = data.id;
        let value = !data.enabled;
        return TAxios.changeEnabled(id, value);
    },
    loadLogs({commit}) {
        return new Promise((resolve, reject) => {
            TAxios.loadLogs()
                .then(response => {
                    commit('SET_LOGS_DATA', response.data.data);
                    resolve(response);
                }).catch(error => {
                    reject(error);
            })
        })
    },
    getTestingSubjects() {
        return TAxios.getTestingSubjects();
    },
    openChangelog({commit}, value) {
        commit('SET_OPEN_CHANGELOG', value);
    },
    createTestSubject({commit, state}, payload) {
      let data = JSON.parse(JSON.stringify(payload.testingSubject));
        return new Promise((resolve, reject) => {
          if (payload.id) {
            TAxios.updateTestingSubject(payload.id, data)
                .then(response => {
                    commit('SET_CREATE_MODAL_ERRORS', {});
                    commit('SET_CREATE_MODAL_DATA', response.data.data)
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_CREATE_MODAL_ERRORS', error.response.data.data);
                    }
                    reject(error);
                })
            return;
          }
           TAxios.createTestingSubject(data)
              .then(response => {
                  commit('SET_CREATE_MODAL_ERRORS', {});
                  commit('SET_CREATE_MODAL_DATA', response.data.data)
                  resolve(response);
              })
              .catch(error => {
                  if (error.response.status === 422) {
                      commit('SET_CREATE_MODAL_ERRORS', error.response.data.data);
                  }
                  reject(error);
              })
        })
    },
}
